(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["te-shipping-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('te-shipping-estimate')) {
    class TeShippingEstimate extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.result = this.querySelector('[role="status"]');
        this.button = this.form.querySelector('button');
        this.variants = JSON.parse(this.querySelector('[data-te-variants]').textContent);
        this.messages = JSON.parse(this.querySelector('[data-te-messages]').textContent);
        this.cache = new Map();
        this.quoteLink = this.querySelector('.te-shipping__quote');
        this.invalidate = () => {
          this.controller?.abort();
          this.result.textContent = '';
          this.quoteLink.hidden = true;
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
        };
        this.form.addEventListener('input', this.invalidate);
        this.form.addEventListener('change', this.invalidate);
        this.productInfo = this.closest('[id^="ProductInfo-"]');
        this.productInfo?.addEventListener('change', this.invalidate);
        this.productInfo?.addEventListener('input', this.invalidate);
        const variantInput = document.getElementById(this.dataset.productForm)?.querySelector('[name="id"]');
        if (variantInput) {
          this.observer = new MutationObserver(this.invalidate);
          this.observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        }
        this.submitHandler = event => { event.preventDefault(); this.calculate(); };
        this.form.addEventListener('submit', this.submitHandler);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.form.removeEventListener('input', this.invalidate);
        this.form.removeEventListener('change', this.invalidate);
        this.form.removeEventListener('submit', this.submitHandler);
        this.productInfo?.removeEventListener('change', this.invalidate);
        this.productInfo?.removeEventListener('input', this.invalidate);
        this.initialized = false;
      }

      selection() {
        const purchaseForm = document.getElementById(this.dataset.productForm);
        const variantId = purchaseForm?.querySelector('[name="id"]')?.value;
        const quantityInput = this.productInfo?.querySelector('[name="quantity"]');
        const quantity = Number(quantityInput?.value || 1);
        const fields = this.form.elements;
        return { variantId, quantity, zip: fields.postcode.value.trim(), provinceCode: fields.state.value, city: fields.suburb.value.trim() };
      }

      async deliveryChecks() {
        if (!TeShippingEstimate.checksPromise) {
          TeShippingEstimate.checksPromise = fetch(this.dataset.deliveryChecks, { credentials: 'omit' })
            .then(response => { if (!response.ok) throw new Error('Delivery data unavailable'); return response.json(); })
            .then(data => {
              if (!data.bySku || !Array.isArray(data.restrictions) || !Array.isArray(data.freeShippingVariantIds)) throw new Error('Invalid delivery data');
              return data;
            }).catch(error => { TeShippingEstimate.checksPromise = null; throw error; });
        }
        return TeShippingEstimate.checksPromise;
      }

      restrictedDestination(data, sku, selection) {
        const index = data.bySku[sku];
        if (!Number.isInteger(index)) return false;
        const locations = data.restrictions[index]?.[selection.zip] || [];
        const normalize = value => value.normalize('NFKC').trim().replace(/\s+/g, ' ').toUpperCase();
        return locations.some(location => normalize(location) === normalize(selection.city));
      }

      showResult(message, needsQuote, selection, variant) {
        this.result.textContent = message;
        this.quoteLink.hidden = !needsQuote;
        if (needsQuote) {
          const body = this.messages.quote_body + '\n\n' + this.dataset.productTitle + '\n' + (variant?.public_title || variant?.title || '') + '\nSKU: ' + (variant?.sku || '') + '\nQuantity: ' + selection.quantity + '\nDestination: ' + selection.city + ', ' + selection.provinceCode + ' ' + selection.zip + '\n' + this.dataset.productUrl;
          this.quoteLink.href = 'mailto:' + this.dataset.contactEmail + '?subject=' + encodeURIComponent(this.messages.quote_subject) + '&body=' + encodeURIComponent(body);
        }
      }

      async request(query, variables, signal) {
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST', credentials: 'omit', signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json, multipart/mixed; deferSpec=20220824' },
          body: JSON.stringify({ query, variables })
        });
        if (!response.ok) throw new Error('Shipping request failed');
        const text = await response.text();
        const contentType = response.headers.get('content-type') || '';
        const boundary = contentType.match(/boundary="?([^";\s]+)"?/i)?.[1];
        const payloads = boundary ? text.split('--' + boundary).flatMap(part => {
          const separator = part.search(/\r?\n\r?\n/);
          if (separator < 0) return [];
          const body = part.slice(separator).trim();
          return body.startsWith('{') ? [JSON.parse(body)] : [];
        }) : [JSON.parse(text)];
        if (!payloads.length || payloads.some(payload => payload.errors?.length || payload.incremental?.some(item => item.errors?.length))) throw new Error('Shipping response unavailable');
        return payloads;
      }

      async calculate() {
        if (!this.form.reportValidity()) return;
        const selection = this.selection();
        const variant = this.variants.find(item => String(item.id) === selection.variantId);
        if (!variant?.available) { this.result.textContent = this.messages.sold_out; return; }
        if (!Number.isInteger(selection.quantity) || selection.quantity < 1 || selection.quantity > 250) { this.result.textContent = this.messages.quantity; return; }
        if (!selection.city) { this.form.elements.suburb.focus(); return; }

        const key = JSON.stringify(selection);
        const cached = this.cache.get(key);
        if (cached && Date.now() - cached.time < 300000) { this.showResult(cached.text, cached.needsQuote, selection, variant); return; }
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const timeout = setTimeout(() => controller.abort('timeout'), 35000);
        this.button.disabled = true;
        this.quoteLink.hidden = true;
        this.result.textContent = this.messages.loading;
        this.setAttribute('aria-busy', 'true');
        try {
          let checks;
          try { checks = await this.deliveryChecks(); }
          catch (error) { if (!controller.signal.aborted) this.showResult(this.messages.checks_error, true, selection, variant); return; }
          if (controller.signal.aborted || key !== JSON.stringify(this.selection())) return;
          if (this.restrictedDestination(checks, variant.sku, selection)) {
            this.showResult(this.messages.restricted, true, selection, variant);
            return;
          }
          const isFreeShippingProduct = checks.freeShippingVariantIds.includes(selection.variantId);
          if (!(Number(variant.weight) > 0) && !isFreeShippingProduct) {
            this.showResult(this.messages.missing_weight, true, selection, variant);
            return;
          }
          const input = {
            lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + selection.variantId, quantity: selection.quantity }],
            buyerIdentity: { countryCode: 'AU' },
            delivery: { addresses: [{ address: { deliveryAddress: { countryCode: 'AU', provinceCode: selection.provinceCode, zip: selection.zip, city: selection.city } }, selected: true, oneTimeUse: true }] }
          };
          const created = (await this.request('mutation ShippingEstimateCart($input: CartInput!) { cartCreate(input: $input) { cart { id totalQuantity lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } } } } userErrors { field message } } }', { input }, controller.signal))[0]?.data?.cartCreate;
          if (!created?.cart || created.userErrors?.length) throw new Error('Estimate cart unavailable');
          const line = created.cart.lines.nodes[0];
          if (created.cart.totalQuantity !== selection.quantity || created.cart.lines.nodes.length !== 1 || line?.quantity !== selection.quantity || line?.merchandise.id !== input.lines[0].merchandiseId) throw new Error('Selected item unavailable');
          const payloads = await this.request('query ShippingEstimateRates($cartId: ID!) { cart(id: $cartId) { id ...ShippingEstimateDelivery @defer } } fragment ShippingEstimateDelivery on Cart { deliveryGroups(first: 10, withCarrierRates: true) { nodes { deliveryOptions { title deliveryMethodType estimatedCost { amount currencyCode } } } pageInfo { hasNextPage } } }', { cartId: created.cart.id }, controller.signal);
          let groups;
          for (const payload of payloads) {
            groups = payload.data?.cart?.deliveryGroups || groups;
            for (const item of payload.incremental || []) groups = item.data?.deliveryGroups || groups;
          }
          if (!groups || groups.pageInfo.hasNextPage) throw new Error('Incomplete shipping response');
          const cheapest = groups.nodes.map(group => group.deliveryOptions.filter(option => option.deliveryMethodType === 'SHIPPING' && !/express|expedited|priority|overnight/i.test(option.title || '')).sort((a, b) => Number(a.estimatedCost.amount) - Number(b.estimatedCost.amount))[0]);
          let resultText = this.messages.unavailable;
          let needsQuote = true;
          if (cheapest.length && cheapest.every(Boolean)) {
            const currency = cheapest[0].estimatedCost.currencyCode;
            const total = cheapest.reduce((sum, option) => sum + Number(option.estimatedCost.amount), 0);
            if (!Number.isFinite(total) || total < 0 || cheapest.some(option => option.estimatedCost.currencyCode !== currency)) throw new Error('Invalid shipping estimate');
            needsQuote = false;
            resultText = total === 0 ? this.messages.free : this.messages.estimate + ' ' + new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format(total);
          }
          if (key === JSON.stringify(this.selection()) && !controller.signal.aborted) {
            this.showResult(resultText, needsQuote, selection, variant);
            this.cache.set(key, { text: resultText, needsQuote, time: Date.now() });
          }
        } catch (error) {
          if (key === JSON.stringify(this.selection()) && (!controller.signal.aborted || controller.signal.reason === 'timeout')) this.showResult(this.messages.error, true, selection, variant);
        } finally {
          clearTimeout(timeout);
          if (this.controller === controller) {
            this.button.disabled = false;
            this.removeAttribute('aria-busy');
          }
        }
      }
    }
    customElements.define('te-shipping-estimate', TeShippingEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
